import React from "react";
import { useRouter } from "next/router";
import LandingProductLoading from "./loading";

import SingleCollectionCard from "./single-collection-card";
import { IHowToLearnDetailInput } from "../types";
import useRequestImmutable from "@shared/hooks/useRequestImmutable";
import howToLearnApi from "../helpers/howToLearnApi";
import InfiniteScrollResult from "./InfiniteScrollResult";
import { IHowToLearnLandingData } from "@features/home/helpers/types";

interface Props {
  productCollection: IHowToLearnDetailInput | undefined;
}
const HowToLearnDetailResult: React.FC<Props> = ({ productCollection }) => {
  const router = useRouter();

  const { data } = useRequestImmutable(
    howToLearnApi.singleHowToLearnRelated(String(router.query.slug)),
    { shouldRetryOnError: false }
  );

  const hasCount = Boolean(productCollection?.data.count_product);

  if (hasCount) {
    return (
      <div className="relative pt-6 px-4 md:px-6 lg:px-10 xl:px-0 xl:max-w-[1200px] mx-auto flex flex-wrap justify-center">
        <InfiniteScrollResult />
      </div>
    );
  }

  if (!data) {
    return (
      <div className="relative px-4 md:px-6 lg:px-10 xl:px-0 xl:max-w-[1200px] mx-auto flex flex-wrap justify-center">
        <LandingProductLoading count={12} />
      </div>
    );
  }

  if (!data.data?.length) return null;
  return (
    <div className="relative px-4 md:px-6 lg:px-10 xl:px-0 xl:max-w-[1200px] mx-auto flex flex-wrap justify-center">
      <div className="flex flex-col w-full fds-md:mt-6">
        <h5 className="fds-md:headline-xlg headline-md">
          دسته‌بندی‌های آموزشی مرتبط
        </h5>
        <div className="w-full grid fds-sm:mb-fds-60 mb-6 fds-md:grid-cols-2 grid-cols-1 gap-6 mt-6 fds-sm:mt-8">
          {data.data.map((course: IHowToLearnLandingData) => (
            <div className="w-full" key={course.id}>
              <SingleCollectionCard
                student={course.count_students}
                product={course.count_product}
                slug={course.slug}
                title={course.title_short || course.title}
                svg_image={course.svg_image}
                png_image={course.png_image}
                duration={course.total_time_hour}
                isFavorite={course.is_favorite}
                id={course.id}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HowToLearnDetailResult;
